import { useEffect, useState } from "react";
import { getData } from "@Src/services/learning/global.service";
import { APIEnv } from "@Src/services/learning/baseInterfaces";

export const useGet = (
  url: string,
  queryParams?: any,
  urlParam?: any,
  APIEnvironment: APIEnv = APIEnv.LEARNING,
  reFetch: any = undefined
) => {
  const [data, setData] = useState<any>();
  const [error, setError] = useState<any>();
  const [loading, setLoading] = useState(false);

  useEffect(
    () => {
      setLoading(true);
      if (reFetch != null || reFetch != undefined) {
        getData(url, queryParams, urlParam, APIEnvironment)
          .then(setData)
          .catch(setError)
          .finally(() => setLoading(false));
      }
    },
    Array.isArray(reFetch) ? reFetch : [reFetch]
  );

  return { data, error, loading };
};
